import http from '../../http';

export async function fetchSettings() {
	return {
		type: 'SETTINGS_UPDATED',
		data: (await http.get('/api/kiosks/coliving/settings')).data,
	};
}
